import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons'; // Import the icon

library.add(faEnvelope);
library.add(faXTwitter);
library.add(faDiscord);
library.add(faArrowLeft);
library.add(faFloppyDisk);

const app = createApp(App);

app.use(router);
app.use(Vue3Toastify);
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app');